import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    id: "participantHeader",
    fluid: "",
    class: "bg-secondary",
    style: {"position":"sticky","top":"74px","z-index":"1002"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        dense: "",
        row: "",
        wrap: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6",
            lg: "8",
            id: "participantInfo"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h1", null, _toDisplayString(_ctx.data.fullName), 1),
              _createElementVNode("h2", null, _toDisplayString(_ctx.data.programName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6",
            lg: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    md: "5",
                    class: "label text-right"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("strong", null, "Participant #:", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    md: "6",
                    class: "value text-left d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.data.participantId), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    md: "5",
                    class: "label text-right"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("strong", null, "Date of Birth:", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    md: "6",
                    class: "value text-left d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.participantDOB), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    md: "5",
                    class: "label text-right"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("strong", null, "SSN:", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    md: "6",
                    class: "value text-left d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.data.ssnLastFour), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}